var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-item"},[_c('div',{staticClass:"top-item"},[_vm._v("专业"+_vm._s(_vm.indexNumber))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-item"},[_c('div',{staticClass:"item-box"},[_vm._v("最低分")]),_c('div',{staticClass:"item-box"},[_vm._v("最低位次")]),_c('div',{staticClass:"item-box"},[_vm._v("录取人数")])])
}]

export { render, staticRenderFns }